import { render, staticRenderFns } from "./NoOfferAssign.vue?vue&type=template&id=0cb85d56&scoped=true&origin=center%20center&"
import script from "./NoOfferAssign.vue?vue&type=script&lang=js&"
export * from "./NoOfferAssign.vue?vue&type=script&lang=js&"
import style0 from "./NoOfferAssign.vue?vue&type=style&index=0&id=0cb85d56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb85d56",
  null
  
)

export default component.exports